"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MapperBuilder_1 = require("./MapperBuilder");
class RegistrationType extends MapperBuilder_1.default {
    constructor() {
        super();
        this.setStatus({
            PERSONAL: 'personal',
            COMPANY: 'company',
        });
        this.setTranslations({
            [this.statusList.PERSONAL]: 'Pessoa Física',
            [this.statusList.COMPANY]: 'Pessoa Jurídica',
        });
        this.setAssertions({
            isPersonal: this.buildAssertFunc(this.statusList.PERSONAL),
            isCompany: this.buildAssertFunc(this.statusList.COMPANY),
        });
    }
}
exports.default = RegistrationType;
//# sourceMappingURL=RegistrationType.js.map